import Vue from 'vue'
import Router from 'vue-router'
// hack router push callback
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router)
import Register from '../view/register.vue'
const createRouter = () => {
  return new Router({
    mode: 'history',
    routes: [
        {
            path: '/register',
            name: 'register',
            component: Register
        }
    ]
  })
}

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}
export default router